import React from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import {Routes,Route,BrowserRouter} from 'react-router-dom';
import Home from './components/Home';
import ClinicReputation from './components/reputation/ClinicReputation';
import SmsConfirmation from './components/sms-gateway/confirmation/SmsConfirmation';
import LinkExpired from './components/link-expired/LinkExpired';
import WelcomeFormPage from './components/patientforms/WelcomeFormPage';
import ContactLensReorderPage from './components/patientforms/ContactLensReorderPage';
import Appointments from './components/patientforms/Appointments';
import ArticlePage from './components/patientforms/Articles'; 
import CommPrefs from './components/patientforms/CommPrefs';
import PickupConfirm from './components/patientforms/PickupConfirm';
import AppointmentCancel from './components/patientforms/AppointmentCancel';
import AppointmentBooking from './components/patientforms/AppointmentBooking';
import UnsubscribePage from './components/patientforms/UnsubscribePage';
import ClinicLayout from './components/layout/ClinicLayout';
import Clinic404 from './components/Clinic404';
function App() {
  return (
    <>
      <BrowserRouter>
          <Routes>
              <Route path="/" element={<Home/>}/>
              {/* /reputation/{shortCode}?pId={patientId} */}
              <Route path="reputation">
                <Route path=":shortCode" element={<ClinicReputation/>}/>
              </Route>

              <Route path="clinics">
                <Route path=":clinicId" element={<ClinicLayout/>}>
                  <Route path="welcome">
                    <Route index element={<Clinic404/>} />
                    <Route path=":patientId" element={<WelcomeFormPage/>} />
                  </Route>
                  <Route path="comm-pref">
                    <Route index element={<Clinic404/>} />
                    <Route path=":patientId" element={<CommPrefs/>} />
                  </Route>
                  <Route path="contact-lens">
                    <Route index element={<Clinic404/>} />
                    <Route path=":patientId" element={<ContactLensReorderPage/>} />
                  </Route>
                  <Route path="appointments">
                    <Route index element={<Clinic404/>} />
                    <Route path=":appointmentId">
                      <Route index element={<Clinic404/>} />
                      <Route path="confirm" element={<Appointments/>} />
                      <Route path="decline" element={<AppointmentCancel/>} />
                      <Route path="*" element={<Clinic404/>} />
                    </Route>
                  </Route>
                  <Route path="appointment-booking" element={<AppointmentBooking/>} />
                  <Route path="article">
                    <Route index element={<Clinic404/>} />
                    <Route path=":articleId" element={<ArticlePage/>} />
                  </Route>

                  <Route path="pickup-confirm">
                    <Route index element={<Clinic404/>} />
                    <Route path=":patientId" element={<PickupConfirm/>} />
                  </Route>
                  <Route path="unsubscribe">
                    <Route index element={<Clinic404/>} />
                    <Route path=":patientId" element={<UnsubscribePage/>} />
                  </Route>
                  <Route path="*" element={<Clinic404/>} />
                </Route>
              </Route>
              <Route path="sms-gateway">
                <Route path="clinic">
                  <Route path=":clinicId">
                    <Route path="confirmation">
                      <Route path=":messageId" element={<SmsConfirmation/>} />
                    </Route>
                  </Route>
                </Route>
              </Route>
              <Route path="link-expired" element={<LinkExpired/>}></Route>
          </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;